import { Option } from "../../DTOs/Common/OptionResponse";
import { StoppageCalc } from "../../DTOs/Stoppage/StoppageCalc";
import { LinkTarget } from "../../utilities/helpers/linkTarget";
import {
  drillingEntryTarget,
  PRODUCTION_CRUSHING_TARGET,
  PRODUCTION_REHANDLE_TARGET,
  productionPatternTarget,
} from "../../utilities/helpers/dashboardLinks";

/** The page that records a machine's latest work this shift, chosen by the job type of that work. */
export function machineLinkTarget(
  row: Pick<StoppageCalc, "latestRowJobType" | "latestRowId">,
  jobTypes: Option<number>[],
): LinkTarget | null {
  switch (jobTypes.find(jobType => jobType.key === row.latestRowJobType)?.label) {
    case "Production Digging": return productionPatternTarget(row.latestRowId);
    case "Blast Hole Drilling": return drillingEntryTarget(row.latestRowId);
    case "Loader": return PRODUCTION_CRUSHING_TARGET;
    case "Digging": return PRODUCTION_REHANDLE_TARGET;
    default: return null;
  }
}
